import React, { useState } from "react";
import { Tabs, Tab, Select, MenuItem, useMediaQuery, Box } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";

const TabsComponent = ({ selectedTab, setSelectedTab }) => {
  const isMobile = useMediaQuery("(max-width:600px)");
  // const isMobile = useMediaQuery('xs')
  const [isDropDownOpen, setIsDropDownOpen] = useState(false);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  const handleDropdownChange = (event) => {
    setSelectedTab(event.target.value);
  };

  const handleDropDownOpen = () => {
    setIsDropDownOpen(true);
  };

  const handleDropDownClose = () => {
    setIsDropDownOpen(false);
  };

  return (
    <>
      {isMobile ? (
        <Select
          value={selectedTab}
          onChange={handleDropdownChange}
          onOpen={handleDropDownOpen}
          onClose={handleDropDownClose}
          fullWidth
          // disableUnderline
          variant="standard"
          IconComponent={() => null}
          renderValue={(value) => (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
              }}
            >
              {value === 0
                ? "Payment Catalogue"
                : value === 1
                ? "Form of Payement"
                : value === 2
                ? "Point of Sale"
                : "History"}
              {isDropDownOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>
          )}
          sx={{
            background: "white",
            height: "68px",
            textAlign: "center",
            textAlignLast: "center",
            display: "flex",
            alignItems: "center",
            color: "#1460AA",
            borderTopRightRadius: "8px",
            borderTopLeftRadius: "8px",
            fontWeight: 600,
            // padding:'0 8px'
            "&::before": {
              borderBottom: "2px solid #1460AA",
            },
          }}
        >
          <MenuItem value={0}>Payment Catalogue</MenuItem>
          <MenuItem value={1}>Form of Payment</MenuItem>
          <MenuItem value={2}>Point of Sale</MenuItem>
          <MenuItem value={3}>History</MenuItem>
        </Select>
      ) : (
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          textColor="primary"
          indicatorColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          outline="none"
        >
          <Tab
            label="Payment Catalogue"
            sx={{
              backgroundColor: selectedTab === 0 ? "#FFFFFF" : "none",
              height: "68px",
              // transition: "box-shadow 0.3 ease",
              boxShadow: selectedTab === 0 ? 10 : 0,
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              textTransform: "none",
              fontFamily: "Open Sans",
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "20px",
              color: "#000000",
              mr: "20px",
            }}
          />
          <Tab
            label="Form of Payment"
            sx={{
              textTransform: "none",
              height: "68px",
              backgroundColor: selectedTab === 1 ? "#FFFFFF" : "none",
              boxShadow: selectedTab === 1 ? 10 : 0,
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              fontFamily: "Open Sans",
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "20px",
              color: "#000000",
              mr: "20px",
            }}
          />
          <Tab
            label="Point of Sale"
            sx={{
              textTransform: "none",
              height: "68px",
              boxShadow: selectedTab === 2 ? 10 : 0,
              backgroundColor: selectedTab === 2 ? "#FFFFFF" : "none",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              fontFamily: "Open Sans",
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "20px",
              color: "#000000",
              mr: "20px",
            }}
          />
          <Tab
            label="History"
            sx={{
              textTransform: "none",
              height: "68px",
              boxShadow: selectedTab === 3 ? 10 : 0,
              backgroundColor: selectedTab === 3 ? "#FFFFFF" : "none",
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              fontFamily: "Open Sans",
              fontWeight: 600,
              fontSize: "16px",
              lineHeight: "20px",
              color: "#000000",
              mr: "20px",
            }}
          />
        </Tabs>
      )}
    </>
  );
};

export default TabsComponent;
